module.exports = __webpack_public_path__ + "static/media/profile-outline.2e4a1f28.svg";